<template>
    <div class="reportBox">
        <div class="title"><b>测评报告</b></div>
        <div class="pistonBox">
            <div class="scoreBox">视唱练耳A级 <b><i>100</i></b> 分</div>
            <div class="wrongQuestion">
                <div class="wrongTilt">
                    <div class="titileTop"><i></i> 错题库</div>
                    <div class="ti">10题</div>
                </div>
                <div class="wrongCenter">
                </div>
            </div>
        </div>
        <el-button v-if="false" class="saveTheTest">保存测试报告到本地</el-button>
    </div>
</template>
<script>
import utils from '../../lib/util'
    export default {
        name:"testReport",
        data() {
            return {
                
            }
        },
        components:{},
        created(){},
        watch: {},
        computed:{},
        mounted(){
            this.$nextTick(()=>{
                //编辑
                if(JSON.stringify(this.$route.query) !== '{}'){
                    this.getWorngPeper(
                        this.$route.query.id
                    )
                }
            })
        },
        methods:{
            getWorngPeper(id){
                let that = this
                that.$axios.post('/paper/acg/userPaperInfo',{
                    userPaperId:id,//用户试卷id
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web')))
                }, res => {
                    var v = res.data.data
                    if (res.data.code == 0) {
                        // that.getPeperInfo(v.paperId,v.generalDtoList,v.roomUserList)
                    }else{
                        if(res.data.msg)
                            that.$message.error(res.data.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            getPeperInfo(){
                let that = this;
                that.$axios.post('/paper/info',{
                    paperId:that.allData.bId,//试卷id
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web')))
                }, res => {
                    var v = res.data
                    if (v.code == 0) {
                        that.$notify({
                            title: v.msg,
                            type: 'success'
                        });
                    } else {
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .reportBox{
        height: 100%;
        width: 100%;
        background-image: url('../../../static/images/report-center.png'), url('../../../static/images/report-buttom.png');
        background-repeat: no-repeat;
        background-position: 50% 20%,0% 100%;
        background-size: 40%,100%;
        position: relative;
        .title{
            position: absolute;
            top: 0%;
            left: 0;
            right: 0;
            height: 10%;
            color: #000;
            font-size: 18px;
            width: 100%;
            display: table;
            b{
                display: table-cell;
                vertical-align: middle;
                margin: auto;
            }
        }
        .pistonBox{
            position: absolute;
            left: 0;
            right: 0;
            top: 10%;
            bottom: 0%;
            overflow-y: auto;
            .scoreBox{
                position: absolute;
                top: 10%;
                left: 0%;
                right: 0%;
                width: 400px;
                font-size: 28px;
                font-weight: bold;
                color: #004BB4;
                margin: auto;
                background-image: url('../../../static/images/report-bg.png');
                background-repeat: no-repeat;
                background-size: 100% 53%;
                background-position: 0px 75%;  
                b{
                    font-size: 70px;
                    font-weight: 900;
                    font-family: unset;
                }
            }
            .wrongQuestion{
                position: absolute;
                top: 30%;
                left: 0;
                right: 0;
                height: 70%;
                width: 50%;
                margin: auto;
                position: relative;
                .wrongTilt{
                    position: absolute;
                    top: 0;
                    height: 35px;
                    width: 100%;
                    border-bottom: 1px solid #ECEDEC;
                    .titileTop{
                        i{
                            height: 18px;
                            width: 17px;
                            border-radius: 1px;
                            display: inline-block;
                            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEqADAAQAAAABAAAAFAAAAAAV6Uf1AAAAqElEQVQ4EWNk8N3myfDv/ywGhv8yDGQBxicMTIxpjAzeWx+TbwjMZsYnTJQbAjLsvwzQIOoAqhnEguEeFkY9ho3elzHEkQX8t+oy/Pl/CVkI06A/DJUMPltvISvCYP9hUEMXwzSI4X8kw390ZYT5AxRGWMIG5lZMr+ELIyxhg9ugoRFGeMIGt9ewhRGesMFt0ECHEdUSJNAgYAlHMQAVbMBikjLDIEUtAKXwN18vSxxdAAAAAElFTkSuQmCC);
                            background-repeat: no-repeat;
                            margin-bottom: -3px;
                        }
                        width: 50%;
                        float: left;
                    }
                    .ti{
                        width: 50%;
                        float:right;
                    }
                }
                .wrongCenter{
                    position: absolute;
                    top: 35px;
                    left: 0;
                    right: 0;
                    bottom: 25px;
                }
            }
        }
        .saveTheTest{
            position: absolute;
            top: 86%;
            left: 0;
            right: 0;
            width: 38%;
            margin: auto;
            background-color: #004BB4;
            color: #fff;
            font-size: 17px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/exam/testReport.vue